export default "__VITE_ASSET__ga_2Rzhl__"